import { Injectable } from '@angular/core';
import { BaseProvider } from '../../shared/providers/base-provider';
import { CommunitySearchNotifier } from '../notifiers/community-search-notifier';
import { CommunitySearchState } from '../states/community-search-state';

@Injectable({ providedIn: 'root' })
export class CommunitySearchProvider extends BaseProvider<CommunitySearchNotifier, CommunitySearchState> {
  constructor() {
    super(CommunitySearchNotifier);
  }
}
